import { PurchaseItem } from '@/types'

export const selectTitleOptions = [
  { value: '', name: 'Select title' },
  { value: 'Mr', name: 'Mr' },
  { value: 'Mrs', name: 'Mrs' },
  { value: 'Dr', name: 'Dr' },
  { value: 'Miss', name: 'Miss' },
  { value: 'Rev', name: 'Rev' },
  { value: 'Prof', name: 'Prof' },
  { value: 'Ms', name: 'Ms' },
  { value: 'Sir', name: 'Sir' }
]

export const loanTermOptions = [
  { value: '', name: 'Select' },
  { value: '1 year', name: '1 year' },
  { value: '2 years', name: '2 years' },
  { value: '3 years', name: '3 years' },
  { value: '4 years', name: '4 years' },
  { value: '5 years', name: '5 years' }
]

export const paymentFrequencyOptions = [
  { value: '', name: 'Select' },
  { value: 'Weekly', name: 'Weekly' },
  { value: 'Fortnightly', name: 'Fortnightly' },
  { value: 'Monthly', name: 'Monthly' }
]

export const martialStatusOptions = [
  { value: '', name: 'Select one option' },
  { value: 'Single', name: 'Single' },
  { value: 'Married', name: 'Married' },
  { value: 'Divorced', name: 'Divorced' },
  { value: 'Separated', name: 'Separated' },
  { value: 'Widowed', name: 'Widowed' },
  { value: 'Defacto', name: 'Defacto' },
  { value: 'Unknown', name: 'Unknown' }
]

export const dependantsOptions = [
  { value: '', name: 'Select one option' },
  { value: 0, name: '0' },
  { value: 1, name: '1' },
  { value: 2, name: '2' },
  { value: 3, name: '3' },
  { value: 4, name: '4' },
  { value: 5, name: '5' },
  { value: 6, name: '6' },
  { value: 7, name: '7' },
  { value: 8, name: '8' },
  { value: 9, name: '9' },
]

export const drivingLicenceOptions = [
  { value: '', name: 'Select one option' },
  { value: 'Full licence', name: 'Full licence' },
  { value: 'Restricted licence', name: 'Restricted licence' },
  { value: 'Learner licence', name: 'Learner licence' },
  { value: 'International licence', name: 'International licence' },
  { value: 'No licence', name: 'No licence' }
]

export const residenceTypeOptions = [
  { value: '', name: 'Select one option' },
  { value: 'B', name: 'Boarding' },
  { value: 'F', name: 'Freehold' },
  { value: 'L', name: 'Living With Parents' },
  { value: 'M', name: 'Mortgage' },
  { value: 'R', name: 'Renting' }
]

// Buying Options keys coming from CMS
// Motorbike, Boats, CarOrVan, CarLightCommVeh, TruckTrailerUnit, TractorAgriImpl, EarthMovingEquipment, LiftingEquipment, ForestryMobiLogMachinery, MotocyclesQuadbikes, OtherPersonal, OtherBusiness
export const purchaseBussinessItems: PurchaseItem[] = [
  { value: '440', title: 'Car or Light Commercial Vehicle', icon: '/icons/buying-options/car-light-comm-veh.svg' },
  { value: '400', title: 'Truck or Trailer Unit', icon: '/icons/buying-options/truck-trailer-unit.svg' },
  { value: '180', title: 'Tractor or Agricultural Implement', icon: '/icons/buying-options/tractor-agri-impl.svg' },
  { value: '100', title: 'Earth Moving Equipment', icon: '/icons/buying-options/earth-moving-equipment.svg' },
  { value: '160', title: 'Lifting Equipment', icon: '/icons/buying-options/lifting-equipment.svg' },
  { value: '110', title: 'Forestry Mobile Logging Machinery', icon: '/icons/buying-options/forestry-mobi-log-machinery.svg' },
  { value: '470', title: 'Motorcycles or Quad Bikes', icon: '/icons/buying-options/motocycles-quadbikes.svg' },
  { value: '990', title: 'Other', icon: '/icons/buying-options/other-business.svg' }  
]

export const purchasePersonalItems: PurchaseItem[] = [
  { value: 'MV', title: 'Car or Van', icon: '/icons/buying-options/car-or-van.svg' },
  { value: 'RM', title: 'Motorbike On or Off Road', icon: '/icons/buying-options/motorbike.svg' },
  { value: 'TB', title: 'Boat', icon: '/icons/buying-options/boats.svg' },
  { value: 'MH', title: 'Other', icon: '/icons/buying-options/other-personal.svg' }
]

export const otherIncomeDescriptionOptions = [
  { value: '', name: 'Select one option' },
  { value: 'IN01', name: 'Rental' },
  { value: 'IN02', name: 'Working for Families' },
  { value: 'IN03', name: 'Superannuation' },
  { value: 'IN04', name: 'WINZ' },
  { value: 'IN05', name: 'Boarder' },
  { value: 'IN06', name: 'ACC' },
  { value: 'IN07', name: 'Investment/shares' },
  { value: 'IN08', name: 'Overseas Income' },
  { value: 'IN09', name: 'Other' }
]

export const occupationOptions = [
  { value: '', name: 'Select one option' },
  { value: '0000', name: 'Accountant' },
  { value: '0002', name: 'Accounts Clerk' },
  { value: '0003', name: 'Actor/ess' },
  { value: '0010', name: 'Administrator' },
  { value: '0013', name: 'Advertising Representative' },
  { value: '0032', name: 'Ambulance Officer' },
  { value: '0049', name: 'Architect' },
  { value: '0053', name: 'Armed Forces' },
  { value: '0081', name: 'Bank Officer' },
  { value: '0088', name: 'Bartender' },
  { value: '1149', name: 'Beneficiary' },
  { value: '0098', name: 'Boat Builder' },
  { value: '0113', name: 'Branch Manager' },
  { value: '0119', name: 'Builder' },
  { value: '0129', name: 'Bus Driver' },
  { value: '0130', name: 'Business Consultant' },
  { value: '0172', name: 'Chef' },
  { value: '0190', name: 'Cleaner' },
  { value: '0209', name: 'Company Manager' },
  { value: '0216', name: 'Computer Technician' },
  { value: '0226', name: 'Contractor - Professional' },
  { value: '0234', name: 'Courier' },
  { value: '0247', name: 'Customer Services' },
  { value: '0310', name: 'Electrician' },
  { value: '0314', name: 'Engineer' },
  { value: '0324', name: 'Executive / Director' },
  { value: '0331', name: 'Factory Worker' },
  { value: '0334', name: 'Farm Hand' },
  { value: '0336', name: 'Farm Manager' },
  { value: '0364', name: 'Finance Manager' },
  { value: '0384', name: 'Foreman' },
  { value: '0389', name: 'Forestry Worker' },
  { value: '0435', name: 'Health Care Worker' },
  { value: '1151', name: 'Home Duties' },
  { value: '0449', name: 'Hotel Worker' },
  { value: '0496', name: 'Labourer' },
  { value: '0512', name: 'Lawyer' },
  { value: '0530', name: 'Loans Officer' },
  { value: '0534', name: 'Machine Operator' },
  { value: '0546', name: 'Manager' },
  { value: '0647', name: 'Meat Worker' },
  { value: '0648', name: 'Mechanic' },
  { value: '0654', name: 'Medical Professional' },
  { value: '0707', name: 'Nurse' },
  { value: '0722', name: 'Office Supervisor' },
  { value: '0723', name: 'Office Worker' },
  { value: '0775', name: 'Pilot' },
  { value: '0786', name: 'Police Officer' },
  { value: '0827', name: 'Process Worker' },
  { value: '0848', name: 'Public Servant' },
  { value: '0870', name: 'Receptionist' },
  { value: '0877', name: 'Religious Officer' },
  { value: '0887', name: 'Retired / Pensioner' },
  { value: '0900', name: 'Sales Manager / Rep' },
  { value: '0909', name: 'School Teacher' },
  { value: '0910', name: 'Scientist' },
  { value: '0916', name: 'Seaman' },
  { value: '0920', name: 'Secretary' },
  { value: '0945', name: 'Shop Assistant' },
  { value: '0973', name: 'Sports Professional' },
  { value: '1000', name: 'Store Manager' },
  { value: '1001', name: 'Storeman' },
  { value: '1005', name: 'Student' },
  { value: '1020', name: 'System Analyst / IT Programmer' },
  { value: '1029', name: 'Taxi Driver' },
  { value: '1030', name: 'Teacher' },
  { value: '1063', name: 'Tradesman' },
  { value: '1079', name: 'Travel Consultant' },
  { value: '1085', name: 'Truck Driver' },
  { value: '1150', name: 'Unemployed' },
  { value: '9999', name: 'Unknown' },
  { value: '1107', name: 'Veterinarian' },
  { value: '1113', name: 'Waiter/ess' }
]

export const employmentTypeOptions = [
  { value: '', name: 'Select one option' },
  { value: 'Full time', name: 'Full time' },
  { value: 'Part time', name: 'Part time' },
  { value: 'Contractor', name: 'Contractor' },
  { value: 'Self employed', name: 'Self employed' },
  { value: 'Casual', name: 'Casual' },
  { value: 'Seasonal', name: 'Seasonal' },
  { value: 'Beneficiary', name: 'Beneficiary' },
  { value: 'Unknown', name: 'Unknown' },
  { value: 'Unemployed', name: 'Unemployed' }
]

export const assetTypeOptions = [
  { value: '', name: 'Select one option' },
  { value: 'AS01', name: 'KiwiSaver' },
  { value: 'AS02', name: 'Investments' },
  { value: 'AS03', name: 'Savings' },
  { value: 'AS04', name: 'Marine Equipment (e.g. Boat)' },
  { value: 'AS05', name: 'Property' },
  { value: 'AS06', name: 'Motor Vehicles, Campervans, Motorcycles' },
  { value: 'AS07', name: 'Farm Equipment' },
  { value: 'AS08', name: 'Shares' },
  { value: 'AS10', name: 'Live stock' },
  { value: 'AS11', name: 'Other' }
]

export const recurringExpenseTypeOptions = [
  { value: '', name: 'Select one option' },
  { value: 'EX10', name: 'Other insurance', additionalInfo: 'Insurance other than home e.g. life, income protection etc.' },
  { value: 'EX11', name: 'Child support/care', additionalInfo: 'Child Support, Day care/ After school care' },
  { value: 'EX12', name: 'Lifestyle', additionalInfo: 'Gym, sport, travel, church, donations' },
  { value: 'EX13', name: 'Other', additionalInfo: 'Savings, Investments, Entertainment, Health equipment/services, Transport, Personal Care, Hobbies' }
]

export const listOfCountries = [
  { value: '', name: 'Select a country' },
  { value: 'NZL', name: 'New Zealand' },
  { value: 'AUS', name: 'Australia' },
  { value: 'AFG', name: 'Afghanistan' },
  { value: 'ALA', name: 'Aland Islands' },
  { value: 'ALB', name: 'Albania' },
  { value: 'DZA', name: 'Algeria' },
  { value: 'ASM', name: 'American Samoa' },
  { value: 'AND', name: 'Andorra' },
  { value: 'AGO', name: 'Angola' },
  { value: 'AIA', name: 'Anguilla' },
  { value: 'ATA', name: 'Antarctica' },
  { value: 'ATG', name: 'Antigua and Barbuda' },
  { value: 'ARG', name: 'Argentina' },
  { value: 'ARM', name: 'Armenia' },
  { value: 'ABW', name: 'Aruba' },
  { value: 'AUT', name: 'Austria' },
  { value: 'AZE', name: 'Azerbaijan' },
  { value: 'BHS', name: 'Bahamas' },
  { value: 'BHR', name: 'Bahrain' },
  { value: 'BGD', name: 'Bangladesh' },
  { value: 'BRB', name: 'Barbados' },
  { value: 'BLR', name: 'Belarus' },
  { value: 'BEL', name: 'Belgium' },
  { value: 'BLZ', name: 'Belize' },
  { value: 'BEN', name: 'Benin' },
  { value: 'BMU', name: 'Bermuda' },
  { value: 'BTN', name: 'Bhutan' },
  { value: 'BOL', name: 'Bolivia' },
  { value: 'BIH', name: 'Bosnia and Herzegovina' },
  { value: 'BWA', name: 'Botswana' },
  { value: 'BVT', name: 'Bouvet Island' },
  { value: 'BRA', name: 'Brazil' },
  { value: 'IOT', name: 'British Indian Ocean Territory' },
  { value: 'BRN', name: 'Brunei Darussalam' },
  { value: 'BGR', name: 'Bulgaria' },
  { value: 'BFA', name: 'Burkina Faso' },
  { value: 'BDI', name: 'Burundi' },
  { value: 'KHM', name: 'Cambodia' },
  { value: 'CMR', name: 'Cameroon' },
  { value: 'CAN', name: 'Canada' },
  { value: 'CPV', name: 'Cape Verde' },
  { value: 'CYM', name: 'Cayman Islands' },
  { value: 'CAF', name: 'Central African Republic' },
  { value: 'TCD', name: 'Chad' },
  { value: 'CHL', name: 'Chile' },
  { value: 'CHN', name: 'China' },
  { value: 'CXR', name: 'Christmas Island' },
  { value: 'CCK', name: 'Cocos  (Keeling) Islands' },
  { value: 'COL', name: 'Colombia' },
  { value: 'COM', name: 'Comoros' },
  { value: 'COG', name: 'Congo' },
  { value: 'COD', name: 'Congo The Democratic Republic of the' },
  { value: 'COK', name: 'Cook Islands' },
  { value: 'CRI', name: 'Costa Rica' },
  { value: 'CIV', name: 'Cote D\'Ivoire' },
  { value: 'HRV', name: 'Croatia' },
  { value: 'CUB', name: 'Cuba' },
  { value: 'CYP', name: 'Cyprus' },
  { value: 'CZE', name: 'Czech Republic' },
  { value: 'DNK', name: 'Denmark' },
  { value: 'DJI', name: 'Djibouti' },
  { value: 'DMA', name: 'Dominica' },
  { value: 'DOM', name: 'Dominican Republic' },
  { value: 'ECU', name: 'Ecuador' },
  { value: 'EGY', name: 'Egypt' },
  { value: 'SLV', name: 'El Salvador' },
  { value: 'GNQ', name: 'Equatorial Guinea' },
  { value: 'ERI', name: 'Eritrea' },
  { value: 'EST', name: 'Estonia' },
  { value: 'ETH', name: 'Ethiopia' },
  { value: 'FLK', name: 'Falkland Islands (Malvinas)' },
  { value: 'FRO', name: 'Faroe Islands' },
  { value: 'FJI', name: 'Fiji' },
  { value: 'FIN', name: 'Finland' },
  { value: 'FRA', name: 'France' },
  { value: 'GUF', name: 'French Guiana' },
  { value: 'PYF', name: 'French Polynesia' },
  { value: 'ATF', name: 'French Southern Territories' },
  { value: 'GAB', name: 'Gabon' },
  { value: 'GMB', name: 'Gambia' },
  { value: 'GEO', name: 'Georgia' },
  { value: 'DEU', name: 'Germany' },
  { value: 'GHA', name: 'Ghana' },
  { value: 'GIB', name: 'Gibraltar' },
  { value: 'GRC', name: 'Greece' },
  { value: 'GRL', name: 'Greenland' },
  { value: 'GRD', name: 'Grenada' },
  { value: 'GLP', name: 'Guadeloupe' },
  { value: 'GUM', name: 'Guam' },
  { value: 'GTM', name: 'Guatemala' },
  { value: 'GIN', name: 'Guinea' },
  { value: 'GNB', name: 'Guinea-Bissau' },
  { value: 'GUY', name: 'Guyana' },
  { value: 'HTI', name: 'Haiti' },
  { value: 'HMD', name: 'Heard Island and McDonald Islands' },
  { value: 'VAT', name: 'Holy See (Vatican City State)' },
  { value: 'HND', name: 'Honduras' },
  { value: 'HKG', name: 'Hong Kong' },
  { value: 'HUN', name: 'Hungary' },
  { value: 'ISL', name: 'Iceland' },
  { value: 'IND', name: 'India' },
  { value: 'IDN', name: 'Indonesia' },
  { value: 'IRN', name: 'Iran Islamic Republic Of' },
  { value: 'IRQ', name: 'Iraq' },
  { value: 'IRL', name: 'Ireland' },
  { value: 'ISR', name: 'Israel' },
  { value: 'ITA', name: 'Italy' },
  { value: 'JAM', name: 'Jamaica' },
  { value: 'JPN', name: 'Japan' },
  { value: 'JOR', name: 'Jordan' },
  { value: 'KAZ', name: 'Kazakhstan' },
  { value: 'KEN', name: 'Kenya' },
  { value: 'KIR', name: 'Kiribati' },
  { value: 'PRK', name: 'Korea Democratic People\'s Republic of' },
  { value: 'KOR', name: 'Korea Republic of' },
  { value: 'KWT', name: 'Kuwait' },
  { value: 'KGZ', name: 'Kyrgyzstan' },
  { value: 'LAO', name: 'Lao People\'s Democratic Republic' },
  { value: 'LVA', name: 'Latvia' },
  { value: 'LBN', name: 'Lebanon' },
  { value: 'LSO', name: 'Lesotho' },
  { value: 'LBR', name: 'Liberia' },
  { value: 'LBY', name: 'Libyan Arab Jamahiriya' },
  { value: 'LIE', name: 'Liechtenstein' },
  { value: 'LTU', name: 'Lithuania' },
  { value: 'LUX', name: 'Luxembourg' },
  { value: 'MAC', name: 'Macao' },
  { value: 'MKD', name: 'Macedonia (Former Yugoslav Republic of)' },
  { value: 'MDG', name: 'Madagascar' },
  { value: 'MWI', name: 'Malawi' },
  { value: 'MYS', name: 'Malaysia' },
  { value: 'MDV', name: 'Maldives' },
  { value: 'MLI', name: 'Mali' },
  { value: 'MLT', name: 'Malta' },
  { value: 'MHL', name: 'Marshall Islands' },
  { value: 'MTQ', name: 'Martinique' },
  { value: 'MRT', name: 'Mauritania' },
  { value: 'MUS', name: 'Mauritius' },
  { value: 'MYT', name: 'Mayotte' },
  { value: 'MEX', name: 'Mexico' },
  { value: 'FSM', name: 'Micronesia Federated States of' },
  { value: 'MDA', name: 'Moldova Republic of' },
  { value: 'MCO', name: 'Monaco' },
  { value: 'MNG', name: 'Mongolia' },
  { value: 'MSR', name: 'Montserrat' },
  { value: 'MAR', name: 'Morocco' },
  { value: 'MOZ', name: 'Mozambique' },
  { value: 'MMR', name: 'Myanmar' },
  { value: 'NAM', name: 'Namibia' },
  { value: 'NRU', name: 'Nauru' },
  { value: 'NPL', name: 'Nepal' },
  { value: 'NLD', name: 'Netherlands' },
  { value: 'ANT', name: 'Netherlands Antilles' },
  { value: 'NCL', name: 'New Caledonia' },
  { value: 'NIC', name: 'Nicaragua' },
  { value: 'NER', name: 'Niger' },
  { value: 'NGA', name: 'Nigeria' },
  { value: 'NIU', name: 'Niue' },
  { value: 'NFK', name: 'Norfolk Island' },
  { value: 'MNP', name: 'Northern Mariana Islands' },
  { value: 'NOR', name: 'Norway' },
  { value: 'OMN', name: 'Oman' },
  { value: 'PAK', name: 'Pakistan' },
  { value: 'PLW', name: 'Palau' },
  { value: 'PSE', name: 'Palestinian Territory Occupied' },
  { value: 'PAN', name: 'Panama' },
  { value: 'PNG', name: 'Papua New Guinea' },
  { value: 'PRY', name: 'Paraguay' },
  { value: 'PER', name: 'Peru' },
  { value: 'PHL', name: 'Philippines' },
  { value: 'PCN', name: 'Pitcairn' },
  { value: 'POL', name: 'Poland' },
  { value: 'PRT', name: 'Portugal' },
  { value: 'PRI', name: 'Puerto Rico' },
  { value: 'QAT', name: 'Qatar' },
  { value: 'REU', name: 'Reunion' },
  { value: 'ROU', name: 'Romania' },
  { value: 'RUS', name: 'Russian Federation' },
  { value: 'RWA', name: 'Rwanda' },
  { value: 'SHN', name: 'Saint Helena' },
  { value: 'KNA', name: 'Saint Kitts and Nevis' },
  { value: 'LCA', name: 'Saint Lucia' },
  { value: 'SPM', name: 'Saint Pierre and Miquelon' },
  { value: 'VCT', name: 'Saint Vincent & the Grenadines' },
  { value: 'WSM', name: 'Samoa' },
  { value: 'SMR', name: 'San Marino' },
  { value: 'STP', name: 'Sao Tome and Principe' },
  { value: 'SAU', name: 'Saudi Arabia' },
  { value: 'SEN', name: 'Senegal' },
  { value: 'SCG', name: 'Serbia and Montenegro' },
  { value: 'SYC', name: 'Seychelles' },
  { value: 'SLE', name: 'Sierra Leone' },
  { value: 'SGP', name: 'Singapore' },
  { value: 'SVK', name: 'Slovakia' },
  { value: 'SVN', name: 'Slovenia' },
  { value: 'SLB', name: 'Solomon Islands' },
  { value: 'SOM', name: 'Somalia' },
  { value: 'ZAF', name: 'South Africa' },
  { value: 'SGS', name: 'South Georgia & South Sandwich Islands' },
  { value: 'ESP', name: 'Spain' },
  { value: 'LKA', name: 'Sri Lanka' },
  { value: 'SDN', name: 'Sudan' },
  { value: 'SUR', name: 'Suriname' },
  { value: 'SJM', name: 'Svalbard and Jan Mayen' },
  { value: 'SWZ', name: 'Swaziland' },
  { value: 'SWE', name: 'Sweden' },
  { value: 'CHE', name: 'Switzerland' },
  { value: 'SYR', name: 'Syrian Arab Republic' },
  { value: 'TWN', name: 'Taiwan' },
  { value: 'TJK', name: 'Tajikistan' },
  { value: 'TZA', name: 'Tanzania United Republic of' },
  { value: 'THA', name: 'Thailand' },
  { value: 'TLS', name: 'Timor-Leste' },
  { value: 'TGO', name: 'Togo' },
  { value: 'TKL', name: 'Tokelau' },
  { value: 'TON', name: 'Tonga' },
  { value: 'TTO', name: 'Trinidad and Tobago' },
  { value: 'TUN', name: 'Tunisia' },
  { value: 'TUR', name: 'Turkey' },
  { value: 'TKM', name: 'Turkmenistan' },
  { value: 'TCA', name: 'Turks and Caicos Islands' },
  { value: 'TUV', name: 'Tuvalu' },
  { value: 'UGA', name: 'Uganda' },
  { value: 'UKR', name: 'Ukraine' },
  { value: 'ARE', name: 'United Arab Emirates' },
  { value: 'GBR', name: 'United Kingdom' },
  { value: 'USA', name: 'United States' },
  { value: 'UMI', name: 'United States Minor Outlying Islands' },
  { value: 'URY', name: 'Uruguay' },
  { value: 'UZB', name: 'Uzbekistan' },
  { value: 'VUT', name: 'Vanuatu' },
  { value: 'VEN', name: 'Venezuela' },
  { value: 'VNM', name: 'Vietnam' },
  { value: 'VGB', name: 'Virgin Islands British' },
  { value: 'VIR', name: 'Virgin Islands U.S.' },
  { value: 'WLF', name: 'Wallis and Futuna' },
  { value: 'ESH', name: 'Western Sahara' },
  { value: 'YEM', name: 'Yemen' },
  { value: 'ZMB', name: 'Zambia' },
  { value: 'ZWE', name: 'Zimbabwe' }
]

export const occupationList = [
  { value: '', name: 'Select an occupation' },
  { value: '0000', name: 'Accountant' },
  { value: '0002', name: 'Accounts Clerk' },
  { value: '0003', name: 'Actor/ess' },
  { value: '0010', name: 'Administrator' },
  { value: '0013', name: 'Advertising Representative' },
  { value: '0032', name: 'Ambulance Officer' },
  { value: '0049', name: 'Architect' },
  { value: '0053', name: 'Armed Forces' },
  { value: '0081', name: 'Bank Officer' },
  { value: '0088', name: 'Bartender' },
  { value: '1149', name: 'Beneficiary' },
  { value: '0098', name: 'Boat Builder' },
  { value: '0113', name: 'Branch Manager' },
  { value: '0119', name: 'Builder' },
  { value: '0129', name: 'Bus Driver' },
  { value: '0130', name: 'Business Consultant' },
  { value: '0172', name: 'Chef' },
  { value: '0190', name: 'Cleaner' },
  { value: '0209', name: 'Company Manager' },
  { value: '0216', name: 'Computer Technician' },
  { value: '0226', name: 'Contractor - Professional' },
  { value: '0234', name: 'Courier' },
  { value: '0247', name: 'Customer Services' },
  { value: '0310', name: 'Electrician' },
  { value: '0314', name: 'Engineer' },
  { value: '0324', name: 'Executive / Director' },
  { value: '0331', name: 'Factory Worker' },
  { value: '0334', name: 'Farm Hand' },
  { value: '0336', name: 'Farm Manager' },
  { value: '0364', name: 'Finance Manager' },
  { value: '0384', name: 'Foreman' },
  { value: '0389', name: 'Forestry Worker' },
  { value: '0435', name: 'Health Care Worker' },
  { value: '1151', name: 'Home Duties' },
  { value: '0449', name: 'Hotel Worker' },
  { value: '0496', name: 'Labourer' },
  { value: '0512', name: 'Lawyer' },
  { value: '0530', name: 'Loans Officer' },
  { value: '0534', name: 'Machine Operator' },
  { value: '0546', name: 'Manager' },
  { value: '0647', name: 'Meat Worker' },
  { value: '0648', name: 'Mechanic' },
  { value: '0654', name: 'Medical Professional' },
  { value: '0707', name: 'Nurse' },
  { value: '0722', name: 'Office Supervisor' },
  { value: '0723', name: 'Office Worker' },
  { value: '0775', name: 'Pilot' },
  { value: '0786', name: 'Police Officer' },
  { value: '0827', name: 'Process Worker' },
  { value: '0848', name: 'Public Servant' },
  { value: '0870', name: 'Receptionist' },
  { value: '0877', name: 'Religious Officer' },
  { value: '0887', name: 'Retired / Pensioner' },
  { value: '0900', name: 'Sales Manager / Rep' },
  { value: '0909', name: 'School Teacher' },
  { value: '0910', name: 'Scientist' },
  { value: '0916', name: 'Seaman' },
  { value: '0920', name: 'Secretary' },
  { value: '0945', name: 'Shop Assistant' },
  { value: '0973', name: 'Sports Professional' },
  { value: '1000', name: 'Store Manager' },
  { value: '1001', name: 'Storeman' },
  { value: '1005', name: 'Student' },
  { value: '1020', name: 'System Analyst / IT Programmer' },
  { value: '1029', name: 'Taxi Driver' },
  { value: '1030', name: 'Teacher' },
  { value: '1063', name: 'Tradesman' },
  { value: '1079', name: 'Travel Consultant' },
  { value: '1085', name: 'Truck Driver' },
  { value: '1150', name: 'Unemployed' },
  { value: '9999', name: 'Unknown' },
  { value: '1107', name: 'Veterinarian' },
  { value: '1113', name: 'Waiter/ess'  }
]